import { useAppContext } from "../hooks/useAppContext";
import { Brand } from "../context/AppProvider";
import { getTranslation } from "../locales/getTranslation";

interface ModalChatBotProps {
  onOpenPrivacy?: () => void;
}

const ModalChatBot = ({ onOpenPrivacy }: ModalChatBotProps) => {
  const { brand, locale } = useAppContext();

  return (
    <div className="flex flex-col items-center justify-center gap-5 rounded-2xl bg-grayscale-solid-elevate-level1 px-8 py-10 shadow">
      <h1 className="text-center text-sm font-bold leading-tight text-grayscale-solid-g10 sm:text-base">
        {getTranslation(locale, "Chatbot Beta Service")}
      </h1>
      <p className="text-center text-xs font-normal leading-[17px] text-grayscale-solid-g10 sm:text-sm">
        {getTranslation(locale, "Chatbot Beta Service Description")}
      </p>
      <ul className="flex flex-col items-center justify-center gap-2.5">
        <li className="h-[3px] w-[3px] rounded-full bg-grayscale-solid-g10"></li>
        <li className="text-center text-[10px] font-normal leading-[14px] text-grayscale-solid-g8 sm:text-[12px]">
          {getTranslation(locale, "Chatbot Sources #4")}
        </li>
        <li className="text-center text-[10px] font-normal leading-[14px] text-grayscale-solid-g8 sm:text-[12px]">
          {getTranslation(locale, "Chatbot Sources #3")}
        </li>
        <li className="text-center text-[10px] font-normal leading-[14px] text-grayscale-solid-g8 sm:text-[12px]">
          {getTranslation(locale, "Chatbot Sources #1")}
        </li>
        <li className="text-center text-[10px] font-normal leading-[14px] text-grayscale-solid-g8 sm:text-[12px]">
          {getTranslation(locale, "Chatbot Sources #2")}
        </li>
        <li className="h-[3px] w-[3px] rounded-full bg-grayscale-solid-g10"></li>
      </ul>
      <p
        className="text-center text-[10px] font-normal leading-[14px] text-grayscale-solid-g10 sm:text-[12px]"
        onClick={(e) => {
          if (
            (e.target as HTMLElement).classList.contains(
              "privacy-notice-trigger",
            )
          ) {
            onOpenPrivacy?.();
          }
        }}
        dangerouslySetInnerHTML={{
          __html:
            brand === Brand.CLO3D
              ? getTranslation(locale, "Chatbot Warning CLO3D") || ""
              : brand === Brand.CLOSET
                ? getTranslation(locale, "Chatbot Warning CLO-SET") || ""
                : brand === Brand.CLOSET_CONNECT
                  ? getTranslation(locale, "Chatbot Warning CONNECT") || ""
                  : brand === Brand.MD
                    ? getTranslation(locale, "Chatbot Warning MD") || ""
                    : "",
        }}
      />
    </div>
  );
};

export default ModalChatBot;
